import React from "react";

const SectionTitle = ({ children }) => {
  return (
    <div
      class="font-serif"
      style={{
        fontVariant: "small-caps",
        textTransform: "capitalize",
        fontSize: "1.1em",
      }}
    >
      {children}
    </div>
  );
};

export default SectionTitle;
